const COOKIE_CTA_SELECTOR =
  '.cc-nb-okagree, .cc-nb-reject, .cc-nb-changep, .cc-cp-foot-save';
const COOKIE_ROOT_SELECTOR =
  '.termsfeed-com---nb, .termsfeed-com---pc-overlay, .termsfeed-com---pc-dialog';
const COOKIE_TRIGGER_SELECTOR =
  '#open_preferences_center, .cc-nb-changep, .cc-nb-okagree, .cc-nb-reject, .cc-pc-head-close, .cc-cp-foot-save, .cc-cp-body-tabs-item-link';

const COOKIE_ENHANCED_CLASS = 'cookies-cta';
const COOKIE_BUTTON_CLASS = 'btn';
const COOKIE_BUTTON_ROLL_ATTRIBUTE = 'data-btn-roll';
const COOKIE_BURST_DELAYS = [0, 150, 400];

const enhancedCookieButtons = new WeakSet();
const cookieBurstTimers = [];

let cookieObserver = null;
let cookieRefreshQueued = false;

const stripLegacyRoll = (button) => {
  button.querySelectorAll('.roll__hover').forEach((node) => node.remove());

  button.querySelectorAll('.roll__original').forEach((node) => {
    const parent = node.parentNode;

    if (!parent) {
      return;
    }

    while (node.firstChild) {
      parent.insertBefore(node.firstChild, node);
    }

    node.remove();
  });

  button.removeAttribute('data-roll');
  button.classList.remove('is-init-roll');
};

const ensureCookieButtonLayout = (button) => {
  if (!button.querySelector('.btn__text')) {
    const text = document.createElement('span');
    text.className = 'btn__text';

    while (button.firstChild) {
      text.appendChild(button.firstChild);
    }

    const icon = document.createElement('span');
    icon.className = 'btn__icon';
    icon.setAttribute('aria-hidden', 'true');

    const glyph = document.createElement('i');
    glyph.className = 'icon-arrow-main';
    icon.appendChild(glyph);

    button.appendChild(text);
    button.appendChild(icon);
  }

  button.classList.add(COOKIE_BUTTON_CLASS);
  button.setAttribute(COOKIE_BUTTON_ROLL_ATTRIBUTE, '');
};

const enhanceCookieButton = (button) => {
  if (!(button instanceof HTMLElement)) {
    return false;
  }

  if (enhancedCookieButtons.has(button)) {
    return false;
  }

  enhancedCookieButtons.add(button);
  button.classList.add(COOKIE_ENHANCED_CLASS);
  stripLegacyRoll(button);
  ensureCookieButtonLayout(button);

  return true;
};

const enhanceCookieRoot = (root) => {
  if (!(root instanceof Element)) {
    return false;
  }

  let changed = false;

  root.querySelectorAll(COOKIE_CTA_SELECTOR).forEach((button) => {
    if (enhanceCookieButton(button)) {
      changed = true;
    }
  });

  return changed;
};

const initCookieRoll = (scope) => {
  if (typeof window.initBtnRoll === 'function') {
    window.initBtnRoll(scope && typeof scope.querySelectorAll === 'function' ? scope : document);
  }
};

const refreshCookieRoot = (root) => {
  if (enhanceCookieRoot(root)) {
    initCookieRoll(root);
  }
};

const refreshCookieRoots = () => {
  window.syncPublicKeyboardFocus?.();
  let changed = false;

  document.querySelectorAll(COOKIE_ROOT_SELECTOR).forEach((root) => {
    if (enhanceCookieRoot(root)) {
      changed = true;
    }
  });

  if (changed) {
    initCookieRoll(document);
  }
};

const queueCookieRefresh = () => {
  if (cookieRefreshQueued) {
    return;
  }

  cookieRefreshQueued = true;

  window.setTimeout(() => {
    cookieRefreshQueued = false;
    refreshCookieRoots();
  }, 0);
};

const refreshCookieNode = (node) => {
  if (!(node instanceof Element)) {
    return;
  }

  const root = node.closest(COOKIE_ROOT_SELECTOR);

  if (root) {
    refreshCookieRoot(root);
    window.syncPublicKeyboardFocus?.();
    return;
  }

  if (node.querySelector(COOKIE_ROOT_SELECTOR)) {
    window.syncPublicKeyboardFocus?.();
    let changed = false;

    node.querySelectorAll(COOKIE_ROOT_SELECTOR).forEach((innerRoot) => {
      if (enhanceCookieRoot(innerRoot)) {
        changed = true;
      }
    });

    if (changed) {
      initCookieRoll(node);
    }

    return;
  }

  if (node.matches(COOKIE_CTA_SELECTOR) || node.querySelector(COOKIE_CTA_SELECTOR)) {
    queueCookieRefresh();
  }
};

const startCookieObserver = () => {
  if (cookieObserver || typeof MutationObserver === 'undefined' || !document.body) {
    return;
  }

  cookieObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          refreshCookieNode(node);
        }
      });
    });
  });

  cookieObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

const handleCookieClick = (event) => {
  const target = event.target;

  if (!(target instanceof Element)) {
    return;
  }

  if (!target.closest(COOKIE_TRIGGER_SELECTOR)) {
    return;
  }

  cookieBurstTimers.forEach((timer) => window.clearTimeout(timer));
  cookieBurstTimers.length = 0;

  COOKIE_BURST_DELAYS.forEach((delay) => {
    cookieBurstTimers.push(window.setTimeout(refreshCookieRoots, delay));
  });
};

const initCookiesPopup = () => {
  refreshCookieRoots();
  startCookieObserver();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookiesPopup, { once: true });
} else {
  initCookiesPopup();
}

document.addEventListener('click', handleCookieClick, true);

window.initCookiesPopup = initCookiesPopup;
